import request from "@/utils/request";

export function getCityInfoList() {
    return request({
        url: `/matedata/cities/info`,
        method: "get",
    });
}
export function getRouteList() {
    return request({
        url: "/matedata/routes/list",
        method: "get",
    });
}

export function companyCount() {
    return request({
        url: "/matedata/company/count",
        method: "get",
    });
}

export function openRouteCount() {
    return request({
        url: "/matedata/open_route/count",
        method: "get",
    });
}

export function vehicleCount() {
    return request({
        url: "/matedata/vehicle/count",
        method: "get",
    });
}

export function vehicleCountByDept() {
    return request({
        url: "/matedata/vehicle/countByDept",
        method: "get",
    });
}

export function openMileageCount() {
    return request({
        url: "/matedata/open_mileage/count",
        method: "get",
    });
}

//车辆类型统计
export function vehicleTypeCount() {
    return request({
        url: "/matedata/vehicleTypeCount",
        method: "get",
    });
}

//
export function companyApplicationInfo() {
    return request({
        url: "/matedata/company/applicationInfo",
        method: "get",
    });
}

//
export function openMileageChangingChart() {
    return request({
        url: "/matedata/open_mileage/changing/chart",
        method: "get",
    });
}

//任务状态统计
export function taskStatusCount() {
    return request({
        url: "/matedata/task/count",
        method: "get",
    });
}

//告警等级统计
export function alarmLevelCount() {
    return request({
        url: "/matedata/alarm/level/count",
        method: "get",
    });
}

//企业告警等级信息统计
export function companyAlarmLevelInfoCount() {
    return request({
        url: "/matedata/alarm/level/countByDept",
        method: "get",
    });
}